import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {ProfileType} from '../../pages/settings/profile-type/profile-type.model';

export interface ProfileTypeRequestParam {
    id: number;
    name: string;
 }

@Injectable()
export class ProfileTypeService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }
    // fetch All Profile Type
    getAllProfileType(): Observable<any> {
        const me = this;
        const profielTypeListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        me.apiRequest.get(this.appConfig.profile_type_url).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                  });
            });

            const commodityObj = Object.assign({}, jsonResp, {
                data: items
            });
            profielTypeListSubject.next(commodityObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return profielTypeListSubject;
    }
    // save profile type
    save(profileType: ProfileType): Observable<any> {
        const me = this;

        const bodyData: ProfileTypeRequestParam = <ProfileTypeRequestParam> {
            'name': profileType.name

        };

        const profileTypeDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.profiles_url, bodyData)
            .subscribe(jsonResp => {
                    let profileTypeInfoReturn: ProfileTypeRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const profileType: ProfileType = jsonResp.data[0];

                        profileTypeInfoReturn = <ProfileTypeRequestParam>{
                           'name': profileType.name
                        };

                    } else {
                        console.log('added:----:' + jsonResp.message);
                    }
                    profileTypeDataSubject.next(profileTypeInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return profileTypeDataSubject;
    }
    // update profile type
    update(profileType: ProfileType, id: number): Observable<any> {
        const me = this;

        const bodyData = {
            'id': profileType.id,
            'name': profileType.name
        };

        const profileTypeDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.put(this.appConfig.profiles_url + '/' + id, bodyData)
            .subscribe(jsonResp => {
                    let profileTypeInfoReturn: ProfileTypeRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const cc: ProfileType = jsonResp.data[0];
                        profileTypeInfoReturn =  <ProfileTypeRequestParam> {
                            'id': cc.id,
                            'name': cc.name,
                        };

                    } else {
                        console.log('updated :----:' + jsonResp.message);
                    }
                    profileTypeDataSubject.next(profileTypeInfoReturn);
                },
                err => {
                    console.log('update  err:----:' + err);
                });

        return profileTypeDataSubject;
    }

    deleteProfileType(id: number): Observable<any> {
        const me = this;
        return me.apiRequest.delete(this.appConfig.profiles_url + '/' + id);
    }
    getProfileTypeDD() {
        const me = this;
        return me.apiRequest.get(this.appConfig.profile_type_dd_url);
    }

}

